<template>
  <div class="login-page">
    <!-- 左侧内容 -->
    <div class="left-content">
      <img src="../assets/logo.png" alt="SDIBAN Logo" class="logo">
      <h1>指尖迷局</h1>
      <p>Gose and pursue expanded private gnol idectors</p>
      <p>去开拓并寻求扩大私域投资的机会</p>
      <!-- 添加三角形图案装饰 -->
      <div class="triangle-pattern"></div>
    </div>
    <!-- 登录表单 -->
    <div class="login-container">
      <el-card class="login-card">
        <div class="login-header">
          <h2>登陆</h2>
        </div>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="0px">
          <el-form-item prop="username">
            <el-input 
              v-model="loginForm.username" 
              placeholder="请输入账号" 
              prefix-icon="el-icon-user"
              @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input 
              v-model="loginForm.password" 
              type="password" 
              placeholder="请输入密码" 
              prefix-icon="el-icon-lock"
              @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="rememberMe">记住账号</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button 
              type="primary" 
              style="width: 100%" 
              @click="handleLogin" 
              :loading="loading"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
        <div class="footer-links">
          <a href="#" @click.prevent="showContactAdmin">帮助</a>
          <a href="#" @click.prevent="showForgotPassword">忘记密码</a>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { post } from '@/utils/http.js'

export default {
  name: 'LoginPage', // 修改为多词名称以符合 ESLint 规则
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false,
      rememberMe: false
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await post('/admin/AdminAccount/login', {
              username: this.loginForm.username,
              password: this.loginForm.password
            });
            
            // 存储token和role到本地
            if(response.code === 200 && response.data) {
              localStorage.setItem('token', response.data.token);
              localStorage.setItem('role', response.data.role);
              
              // 如果选择了"记住我"，可以存储用户名
              if (this.rememberMe) {
                localStorage.setItem('rememberedUsername', this.loginForm.username);
              } else {
                localStorage.removeItem('rememberedUsername');
              }
            }
            
            // 登录成功后跳转到主页面
            this.$router.push('/data-dashboard');  // 修改为跳转到数据大屏页面
            this.$message.success('登录成功');
          } catch (error) {
            this.$message.error(error.message || '登录失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    showForgotPassword() {
      this.$message.info('请联系系统管理员重置密码');
    },
    showContactAdmin() {
      this.$message.info('请联系系统管理员获取帮助');
    }
  },
  mounted() {
    // 页面加载时，如果有记住的用户名则填充
    const rememberedUsername = localStorage.getItem('rememberedUsername');
    if (rememberedUsername) {
      this.loginForm.username = rememberedUsername;
      this.rememberMe = true;
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: url('../assets/bg-login.jpg') no-repeat center center; /* 使用新的背景图片 */
  background-size: cover;
  padding: 20px;
}

.left-content {
  width: 50%;
  text-align: center;
  color: white;
}

.logo {
  width: 120px;
  /* margin-bottom: 20px; */
}

.left-content h1 {
  font-size: 48px;
  margin-bottom: 10px;
}

.left-content p {
  font-size: 16px;
  opacity: 0.7;
}

.login-container {
  width: 50%;
  max-width: 400px;
  position: relative;
}

.login-card {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.85);
  position: relative;
  z-index: 1;
  margin-top: 50px; /* 调整登录卡片位置 */
}

.login-header {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  padding: 20px 0;
  margin-bottom: 20px;
}

.footer-links {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.footer-links a {
  color: #909399;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #409EFF;
}

.el-form {
  padding: 0 20px 10px;
}

.el-input__prefix {
  color: #C0C4CC;
}

/* 添加装饰性圆环 */
.decorative-ring {
  position: absolute;
  top: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  height: 400px;
  border: 20px solid #FFD700;
  border-radius: 50%;
  opacity: 0.8;
  z-index: -1;
}

.triangle-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
}

.triangle-pattern::before,
.triangle-pattern::after {
  content: '';
  position: absolute;
  width: 50%;
  height: 50%;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2Ij4KICA8cGF0aCBkPSJNMCAwaDI1NnYyNTZoLTI1NnoiIGZpbGw9IiNGRkYiLz4KPC9zdmc+');
  background-size: cover;
}

.triangle-pattern::before {
  top: 0;
  left: 0;
}

.triangle-pattern::after {
  bottom: 0;
  right: 0;
  transform: rotate(180deg);
}

@media (max-width: 768px) {
  .login-page {
    flex-direction: column;
    justify-content: flex-start;
    padding: 16px;
    padding-top: 40px;
  }

  .left-content {
    width: 100%;
    margin-bottom: 24px;
  }

  .left-content h1 {
    font-size: 28px;
  }

  .left-content p {
    font-size: 14px;
    margin: 4px 0;
  }

  .logo {
    width: 80px;
  }

  .login-container {
    width: 100%;
    max-width: none;
  }

  .login-card {
    margin-top: 0;
  }

  .login-header {
    font-size: 20px;
    padding: 16px 0 12px;
    margin-bottom: 12px;
  }
}
</style>